import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { combineLatest, Observable, take } from 'rxjs';

import { ScheduledPaymentSelectors } from '@amfam/billing/schedulepayment/data-access';
import { ScheduledPayment } from '@amfam/shared/models';
import { routerQuery } from '@amfam/shared/utility/navigation';
import { LoadingSpinnerService } from '@amfam/ui-kit';

import { OneTimePayActions, OneTimePayFeatureFacade } from '../../..';
import {
  AccountForSimplifiedPayment,
  simplifiedPaymentReviewData
} from '../../+state/one-time-pay-feature.models';

@Component({
  selector: 'amfam-phoenix-choose-account-wrapper',
  templateUrl: './phoenix-choose-account-wrapper.compnent.html',
  styleUrls: ['./phoenix-choose-account-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PhoenixChooseAccountWrapperComponent implements OnInit {
  accountSelectionFormGroup: FormGroup;
  paymentDateValue = new Date();
  billAccountOptions$: Observable<AccountForSimplifiedPayment[]>;
  billAccountOptionFiltered: AccountForSimplifiedPayment[];
  scheduledPayments: ScheduledPayment[];
  reviewPaymentInfo: simplifiedPaymentReviewData;
  selectedAccounts: {
    billAccountNumber: string;
    selectedPaymentAmount: string;
    dueDate: string;
    paymentTerm: string;
  }[] = [];

  constructor(
    private store: Store,
    private spinner: LoadingSpinnerService,
    private formBuilder: FormBuilder,
    private oneTimePayFacade: OneTimePayFeatureFacade
  ) {}
  ngOnInit(): void {
    this.billAccountOptions$ =
      this.oneTimePayFacade.getSimplifiedPaymentBillAccountsWithAlertMessageList();
    this.getForm();
  }

  submit() {
    const regex = /[$,]/g;
    const iframeToken =
      'HostedPaymentStatus=Complete&TransactionSetupID=49E3D9B5-FAC6-4433-AA78-3D2423257C4A&TransactionID=499573107&ExpressResponseCode=0&ExpressResponseMessage=Success&ApprovalNumber=660669&LastFour=4444&ValidationCode=3DC89F98A9304372&CardLogo=Mastercard&Bin=555555&Entry=Manual&NetTranID=MCC266077&TranDT=2025-04-11%2009:12:13&TimeStamp=KTQv%2fiElTOvO%2fCr5Oq2w27AFIfyHkPky4Spe1UchjjW76NTWT%2fqTkpahTDreimF%2b'; //This value needs to be extracted from the token received from iframe.
    const iframeParts = iframeToken.split('&');
    const lastFour = iframeParts
      .find(iframePart => iframePart.indexOf('LastFour') >= 0)
      .replace('LastFour=', '');
    const cardType = iframeParts
      .find(iframePart => iframePart.indexOf('CardLogo') >= 0)
      .replace('CardLogo=', '');
    this.reviewPaymentInfo = {
      paymentDate: new Date().toISOString(),
      iframeToken,
      totalAmount: this.accountSelectionFormGroup
        .get(this.billAccountOptionFiltered[0].id)
        .value.paymentOptions['amount'].replace(regex, ''),
      policyNumber: this.billAccountOptionFiltered[0].id,
      cardDetails: cardType === 'Amex' ? 'American Express' : cardType + ' ' + lastFour
    };
    this.oneTimePayFacade.registerBillAccountsBeforeOneTimePayPhoenix(this.reviewPaymentInfo);
  }

  getForm(): void {
    combineLatest([
      this.store.select(routerQuery.getRouterPreviousStateUrl),
      this.billAccountOptions$,
      this.store.select(ScheduledPaymentSelectors.selectScheduledPayments)
    ])
      .pipe(take(1))
      .subscribe(([previousUrl, billAccountOptions, scheduledPayments]) => {
        this.scheduledPayments = scheduledPayments;
        this.store.dispatch(OneTimePayActions.setOneTimePayCancelPath({ url: previousUrl }));

        this.billAccountOptionFiltered = billAccountOptions.filter(ba => ba.isSelected);
        const paymentOptions = this.billAccountOptionFiltered[0].paymentOptions.filter(
          paymentOption => paymentOption.text !== 'Other amount'
        );
        this.billAccountOptionFiltered[0].paymentOptions = paymentOptions;
        const formControls = billAccountOptions
          .filter(billAccountOption => billAccountOption.isSelected)
          .map(
            billAccountOption =>
              new FormControl({
                value: billAccountOption.isSelected,
                disabled: billAccountOption.isDisabled
              })
          );

        this.accountSelectionFormGroup = this.formBuilder.group({
          option: new FormArray(formControls)
        });

        billAccountOptions
          .filter(billAccountOption => billAccountOption.isSelected)
          .map(billAccountOption => {
            this.accountSelectionFormGroup.addControl(
              billAccountOption.id,
              this.formBuilder.group({
                paymentOptions: new FormControl({
                  value: billAccountOption.paymentOptions[0],
                  disabled: !billAccountOption.isSelected
                }),
                otherAmount: new FormControl()
              })
            );
          });

        this.spinner.stop();
      });
  }
}
